import {
  getBackgroundStyle,
  resolveColorToBrandkitColorIfNeeded,
} from "pages/media/components/storyboardEditor/helpers/itemsHelper/";
import { getRelativeDimentionsToCalculateRadius } from "../../../../../helpers";
import { Shape, SHAPE_TYPES } from "../../../../../types";
import { useTemplateData } from "../../../../../hooks/useTemplateData";
import { BrandKit } from "pages/media/types/";

export const ShapeRenderer: React.FC<{
  shape: Shape;
  previewWidth: number;
  previewHeight: number;
}> = ({ shape, previewWidth, previewHeight }) => {
  const {
    brandKitData: { brandKitPalette },
  } = useTemplateData();

  const style = getShapeStyle(shape, brandKitPalette);
  const borderRadius = shape.stroke?.radius
    ? shape.stroke.radius *
      getRelativeDimentionsToCalculateRadius(previewWidth, previewHeight)
    : 0;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        border: shape.stroke?.width
          ? `solid ${shape.stroke.width * previewWidth}px ${resolveColorToBrandkitColorIfNeeded(shape.stroke.color ?? undefined, brandKitPalette)}`
          : "none",
        borderRadius,
        ...style,
      }}
    />
  );
};

const getShapeStyle = (
  shape: Shape,
  brandkitPalette: BrandKit["palette"] | undefined
): React.CSSProperties => {
  const { shapeType, background } = shape;

  switch (shapeType) {
    case SHAPE_TYPES.RECTANGLE:
    case SHAPE_TYPES.LINE:
      return getBackgroundStyle(background, brandkitPalette);
    case SHAPE_TYPES.CIRCLE:
      return {
        ...getBackgroundStyle(background, brandkitPalette),
        borderRadius: "50%",
      };
    default:
      return {};
  }
};
